import { render, staticRenderFns } from "./SimpleChooser.vue?vue&type=template&id=1fe5140a&scoped=true"
import script from "./SimpleChooser.vue?vue&type=script&lang=ts"
export * from "./SimpleChooser.vue?vue&type=script&lang=ts"
import style0 from "./SimpleChooser.vue?vue&type=style&index=0&id=1fe5140a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5140a",
  null
  
)

export default component.exports